import UsuarioCard from "./UsuarioCard";

const UsuarioList = ({ usuarioList, onEditar, onRemover }) => {
  if (!usuarioList?.length) return null;

  return (
    <div className="bo-section">
      <div className="bo-section-title">
        Usuários cadastrados ({usuarioList.length})
      </div>

      {usuarioList.map((usuario, index) => (
        <UsuarioCard
          key={usuario._id}
          usuario={usuario}
          onEditar={onEditar ? () => onEditar(usuario._id) : undefined}
          onRemover={onRemover ? () => onRemover(usuario._id) : undefined}
        />
      ))}
    </div>
  );
};

export default UsuarioList;
